module.exports = __webpack_public_path__ + "static/img/wella-logo.135db64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wella-logo.png
// module id = VE4s
// module chunks = 1